import type { AuthenticatedUser } from '../../../../auth/types/AuthenticatedUser'
import { initialState as initialStateActiviteiten } from '../../../activiteiten/services/searchActiviteiten'
import { initialState as initialStateAssignedBijlagen } from '../../../bijlagen/services/searchAssignedBijlagen'
import { initialState as initialStateProjecten } from '../../../projecten/services/searchProjecten'
import type { FetchWerklijstenFilters } from '../../types/FetchWerklijsten'
import type { Werklijst } from '../../types/Werklijst'

export {
  generateActiesQuery,
  generateAssignedBijlagenQuery,
  generateActiviteitenQuery,
}

const generateActiesQuery = ({
  werklijst,
  filters,
  user,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  user: AuthenticatedUser
}) => {
  const { code, label } = werklijst
  const actiehouder = user.deelnemer
    ? { group: '', label: user.organisatie }
    : filters.organisatie

  const query = {
    filters: {
      ...initialStateProjecten.query.filters,
      ...filters,
      actie: { code, label },
      actiehouder,
    },
    page: initialStateProjecten.query.page,
    sort: initialStateProjecten.query.sort,
  }

  return { query, url: '/aansluiting/projecten' }
}

const generateAssignedBijlagenQuery = ({
  werklijst,
  filters,
  kpiColor,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  kpiColor?: string
}) => {
  const { label } = werklijst

  const query = {
    filters: {
      ...initialStateAssignedBijlagen.query.filters,
      ...filters,
      documentsoort: [label],
      assignedTo: filters.organisatie ? [filters.organisatie] : [],
    },
    page: initialStateAssignedBijlagen.query.page,
    sort: initialStateAssignedBijlagen.query.sort,
  }

  if (kpiColor) {
    query.filters.kpi = kpiColor
  }

  return { query, url: '/aansluiting/bijlagen' }
}

const generateActiviteitenQuery = ({
  werklijst,
  filters,
  kpiColor,
}: {
  werklijst: Werklijst
  filters: FetchWerklijstenFilters
  kpiColor?: string
}) => {
  const { code, label } = werklijst

  const query = {
    filters: {
      ...initialStateActiviteiten.query.filters,
      ...filters,
      type: [{ code, label }],
      assignedTo: filters.organisatie ? [filters.organisatie] : [],
    },
    page: initialStateActiviteiten.query.page,
    sort: initialStateActiviteiten.query.sort,
  }

  if (kpiColor) {
    query.filters.kpi = kpiColor
  }

  return { query, url: '/aansluiting/activiteiten' }
}
